import { compose } from "redux";

import SummaryActivity from ".";
import Default from "./Default";
import Error from "../Error";
import withContainer from "../common/hoc/WithContainer";
import asList from "../common/hoc/AsList";
import extractQueryParams from "./ExtractQueryParams";
import extractQueryResults from "../ExtractQueryResults";
import injectWrapper from "./InjectWrapper";

import { search } from "../../services/MODSService";

const type = "Activity";
export default compose(
    // TODO: find a way to NOT hard code object types
    extractQueryParams(type),
    withContainer({
        dataParams: {
            fetchHandler: search
        },
        defaultLoadingMessage: "Loading Activities",
        Error,
        DefaultComponent: Default
    }),
    extractQueryResults(),
    injectWrapper(),
    asList()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
)(SummaryActivity) as React.FunctionComponent<any>;
